module.exports = __webpack_public_path__ + "img/en.9dd5e1ef.svg";